import React from 'react';
import { Shield, Lock, Key, Eye, Server, Database } from 'lucide-react';

const FloatingElements = () => {
  const elements = [
    { Icon: Shield, x: '10%', y: '20%', delay: 0, size: 'w-8 h-8' },
    { Icon: Lock, x: '85%', y: '15%', delay: 0.5, size: 'w-6 h-6' },
    { Icon: Key, x: '15%', y: '70%', delay: 1, size: 'w-7 h-7' },
    { Icon: Eye, x: '80%', y: '65%', delay: 1.5, size: 'w-6 h-6' },
    { Icon: Server, x: '5%', y: '45%', delay: 2, size: 'w-5 h-5' },
    { Icon: Database, x: '90%', y: '40%', delay: 2.5, size: 'w-5 h-5' },
  ];

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {elements.map(({ Icon, x, y, delay, size }, index) => (
        <div
          key={index}
          className="absolute animate-float-slow"
          style={{
            left: x,
            top: y,
            animationDelay: `${delay}s`,
          }}
        >
          <div className="relative group">
            {/* Glow effect */}
            <div className="absolute inset-0 bg-cyan-500/20 rounded-full blur-lg animate-pulse" />
            
            {/* Icon container */}
            <div className="relative p-3 bg-slate-900/80 backdrop-blur-sm border border-slate-700/50 rounded-xl">
              <Icon className={`${size} text-cyan-400/70`} />
            </div>
          </div>
        </div>
      ))}

      {/* Additional decorative elements */}
      <div className="absolute left-[30%] top-[10%] w-2 h-2 bg-cyan-400/40 rounded-full animate-ping" style={{ animationDuration: '3s' }} />
      <div className="absolute left-[60%] top-[80%] w-2 h-2 bg-teal-400/40 rounded-full animate-ping" style={{ animationDuration: '2.5s', animationDelay: '1s' }} />
      <div className="absolute left-[75%] top-[30%] w-1.5 h-1.5 bg-cyan-400/30 rounded-full animate-ping" style={{ animationDuration: '4s', animationDelay: '0.5s' }} />
      <div className="absolute left-[25%] top-[55%] w-1.5 h-1.5 bg-teal-400/30 rounded-full animate-ping" style={{ animationDuration: '3.5s', animationDelay: '1.5s' }} />
    </div>
  );
};

export default FloatingElements;
